<template>
  <WizardTempWifiConnectStep
    v-if="wizardStep === 1"
    :handleNextStep="onNextStepClick"
    :isUpdate="true"
    title="온도조절기 와이파이 변경"
  />
</template>

<script setup>
import {
  ref,
  getCurrentInstance,
  computed,
  onMounted,
  onBeforeMount,
  onBeforeUnmount,
  watch,
  reactive,
} from 'vue';
import { useStore } from 'vuex';
import { useRoute, useRouter } from 'vue-router';
import Axios, { ZoneApi, GroupApi, CtrlApi } from '@/api';
import { DeviceDefault, SettingConfig } from '@/common/constants';
import useMobile from '@/common/hooks/useMobile';
import useMqttControl from '@/common/hooks/useMqttControl';
import WizardTempWifiConnectStep from './components/wizard/WizardTempWifiConnectStep';
import WizardTempDeviceRegistStep from './components/wizard/WizardTempDeviceRegistStep';
import WizardTempRegistCompleteStep from './components/wizard/WizardTempRegistCompleteStep';

const { emitter, mobile, mqtt } = getCurrentInstance().appContext.config.globalProperties;
const store = useStore();
const router = useRouter();
const route = useRoute();

const wizardStep = ref(1);
const serialCode = ref('');

const onNextStepClick = async (params) => {
  try {
    if (wizardStep.value === 1) {
      serialCode.value = params.serialCode;
      emitter.emit('hideLoading', true);

      emitter.emit('showPopAlert', {
        description: '온도조절기 와이파이가 변경되었습니다.',
        okCallback: () => router.go(-1),
        cancelCallback: () => router.go(-1),
      });
      return;
    } else if (wizardStep.value === 2) {
    } else if (wizardStep.value === 3) {
    } else {
      return;
    }

    wizardStep.value += 1;
  } catch (err) {
    console.log(err);
    if (err?.length > 0) {
      showPopAlert(err);
    }
  }
};

onBeforeMount(() => {  
  emitter.emit('onChangeHeaderSetting',{title:'온도 조절기 설정',isShowMenu:false,isShowZone:false,isShowProfile:false,isShowRightHome:true});    
});
onBeforeUnmount(() =>{
  emitter.emit('onChangeHeaderSetting',{title:'',isShowMenu:true,isShowZone:true,isShowProfile:true,isShowRightHome:false});  
})
</script>